<template>
  <div v-if="data" class="page-title" style="margin-bottom: 30px">
    <h2 v-if="data.subtitle" class="page-subtitle" v-html="data.subtitle"></h2>
    <h1 v-if="data.title" v-html="data.title"></h1>
    <span v-if="data.disclaimer" class="title-disclaimer" v-html="data.disclaimer"></span>
  </div>
</template>

<script>
export default {
  name: 'Pagetitle',
  props: ['data'],
}
</script>



// WEBPACK FOOTER //
// BlockPageTitle.vue?6e02bea0